// extracted by mini-css-extract-plugin
export default {"root":"ReplaceTooltip_root__6BM4E"};